export default __webpack_public_path__ + "static/media/production-about-us-hero.3f92c54e.png";